'use client'

import React, { useEffect, useState } from 'react'
import {
  additionalShopPageitems,
  blogmenuItems,
  homePages,
  othersMenuItems,
  shopDetails,
  shopList,
} from '@/data/menu'
import Link from 'next/link'
import { usePathname } from 'next/navigation'
import styles from './MobileNav.module.css'
import { ChevronDown, ChevronRight, ChevronUp } from 'react-bootstrap-icons'
import { storeInfoMenuItems, dashboardMenuItems } from '@/data/menu'
import MobileCustomPictureNav from './MobileCustomPictureNav'

export default function MobileNav({
  headerStyle,
  brand,
  cusomNav,
  categoryItems,
}) {
  // 漢堡開合
  const [expanded, setExpanded] = useState({})
  const [activeNavByClick, setActiveNavByClick] = useState(null)
  const [activeMenu, setActiveMenu] = useState(null)

  const pathname = usePathname()
  // const storePaths = storeInfoMenuItems.map((item) => item.href)
  // const memberPaths = dashboardMenuItems.map((item) => item.href)
  // const isStoreItem = storePaths.some((path) => pathname?.startsWith(path))
  // const isMemberItem = memberPaths.some((path) => pathname?.startsWith(path))

  const isProductActive = activeNavByClick === 'Product'

  const isBrandActive = activeNavByClick === 'Brand'

  const isCustomActive = activeNavByClick === 'Custom'

  const resolveHref = (node) => {
    if (node.IsInternalURL) {
      return node?.LinkURL
        ? `${node.LinkURL.trim()}/${node.LinkURLPagePara?.trim() ?? ''}`
        : '#'
    } else {
      return node?.ExternalURL?.trim() || '#'
    }
  }

  const selectors = {
    mobileMenuActivator: '.mobile-nav-activator',
    mobileMenu: '.navigation',
    mobileMenuActiveClass: 'mobile-menu-opened',
    mobileSubNavOpen: '.js-nav-right',
    mobileSubNavClose: '.js-nav-left',
    mobileSubNavHiddenClass: 'd-none',
  }

  const toggleNode = (id) =>
    setExpanded((prev) => ({ ...prev, [id]: !prev[id] }))

  const isExpanded = (id) => !!expanded[id]

  const hasChildren = (node) =>
    Array.isArray(node?.Children) && node.Children.length > 0

  useEffect(() => {
    const mobileMenuActivator = document.querySelector(
      selectors.mobileMenuActivator
    )
    const mobileDropdown = document.querySelector(selectors.mobileMenu)
    let transformLeft = 0

    const toggleMobileMenu = (event) => {
      if (event) {
        event.preventDefault()
      }

      if (document.body.classList.contains(selectors.mobileMenuActiveClass)) {
        document.body.classList.remove(selectors.mobileMenuActiveClass)
        document.body.style.paddingRight = ''
        mobileDropdown.style.paddingRight = ''
      } else {
        document.body.classList.add(selectors.mobileMenuActiveClass)
        document.body.style.paddingRight = 'scrollWidth' // Replace with appropriate value
        mobileDropdown.style.paddingRight = 'scrollWidth' // Replace with appropriate value
      }
    }

    if (mobileDropdown) {
      mobileMenuActivator &&
        mobileMenuActivator.addEventListener('click', toggleMobileMenu)

      const mobileMenu = mobileDropdown.querySelector('.navigation__list')
      let menuMaxHeight = mobileMenu.offsetHeight

      const openSubNav = (event, btn) => {
        event.preventDefault()
        btn.nextElementSibling.classList.remove(
          selectors.mobileSubNavHiddenClass
        )

        transformLeft -= 100
        if (menuMaxHeight < btn.nextElementSibling.offsetHeight) {
          mobileMenu.style.transform = `translateX(${transformLeft}%)`
          mobileMenu.style.minHeight = `${btn.nextElementSibling.offsetHeight}px`
        } else {
          mobileMenu.style.transform = `translateX(${transformLeft}%)`
          mobileMenu.style.minHeight = `${menuMaxHeight}px`
        }
      }

      const closeSubNav = (event, btn) => {
        event.preventDefault()
        transformLeft += 100
        mobileMenu.style.transform = `translateX(${transformLeft}%)`
        btn.parentElement.classList.add(selectors.mobileSubNavHiddenClass)
        const wrapper = btn.closest('.sub-menu')
        if (wrapper) {
          const minHeight =
            menuMaxHeight < wrapper.offsetHeight
              ? wrapper.offsetHeight
              : menuMaxHeight
          mobileMenu.style.minHeight = `${minHeight}px`
        }
      }

      mobileMenu &&
        Array.from(
          mobileMenu.querySelectorAll(selectors.mobileSubNavOpen)
        ).forEach((btn) => {
          btn.addEventListener('click', (event) => openSubNav(event, btn))
        })

      mobileMenu &&
        Array.from(
          mobileMenu.querySelectorAll(selectors.mobileSubNavClose)
        ).forEach((btn) => {
          btn.addEventListener('click', (event) => closeSubNav(event, btn))
        })

      return () => {
        mobileMenuActivator &&
          mobileMenuActivator.removeEventListener('click', toggleMobileMenu)
        mobileMenu &&
          Array.from(
            mobileMenu.querySelectorAll(selectors.mobileSubNavOpen)
          ).forEach((btn) => {
            btn.removeEventListener('click', (event) => openSubNav(event, btn))
          })
        mobileMenu &&
          Array.from(
            mobileMenu.querySelectorAll(selectors.mobileSubNavClose)
          ).forEach((btn) => {
            btn.removeEventListener('click', (event) => closeSubNav(event, btn))
          })
      }
    }
  }, [])

  //產生巢狀類別選單
  const renderCategories = (items = []) => {
    return items.map((cat) => {
      const children = hasChildren(cat) ? cat.Children : []
      const open = isExpanded(cat.CategoryID)
      const isLeaf = children.length === 0 // 沒有子層才可點

      return (
        <li
          key={`cat-${cat.CategoryID || cat.MenuID}`}
          className="sub-menu__item"
        >
          <div className="d-flex align-items-center justify-content-between">
            {/* 左側：分類連結或展開 */}
            {isLeaf ? (
              // 沒子層 → 可以點擊導向
              <Link
                href={`/product-list?categoryid=${cat.CategoryID}`}
                className="menu-link py-2 flex-grow-1"
                onClick={() =>
                  document.body.classList.remove(
                    selectors.mobileMenuActiveClass
                  )
                }
                style={{ verticalAlign: 'middle' }}
              >
                {cat.CategoryName}
              </Link>
            ) : (
              // 有子層 → 只能展開收合
              <span
                onClick={() => toggleNode(cat.CategoryID)}
                className="menu-link py-2 flex-grow-1"
                style={{ cursor: 'pointer', verticalAlign: 'middle' }}
              >
                {cat.CategoryName}
              </span>
            )}

            {/* 右側：展開箭頭 */}
            {children.length > 0 && (
              <span
                onClick={() => toggleNode(cat.CategoryID)}
                style={{ cursor: 'pointer', fontSize: 16, userSelect: 'none' }}
              >
                {open ? <ChevronDown /> : <ChevronRight />}
              </span>
            )}
          </div>

          {/* 子層 */}
          <div
            className={`${styles.collapseWrapper} ${open ? styles.open : ''}`}
          >
            <ul className="sub-menu__list list-unstyled ps-3">
              {renderCategories(children)}
            </ul>
          </div>
        </li>
      )
    })
  }

  const renderBrand = (items = []) => {
    return items.map((b) => {
      const children = hasChildren(b) ? b.Children : []
      const open = isExpanded(b.BrandID)
      const isLeaf = children.length === 0 // 沒有子層才可點

      return (
        <li key={`brand-${b.BrandID}`} className="sub-menu__item">
          <div className="d-flex align-items-center justify-content-between">
            {/* 左側：分類連結或展開 */}
            {isLeaf ? (
              // 沒子層 → 可以點擊導向
              <Link
                href={`/product-list?brandid=${b.BrandID}`}
                className="menu-link py-2 flex-grow-1"
                onClick={() =>
                  document.body.classList.remove(
                    selectors.mobileMenuActiveClass
                  )
                }
                style={{ verticalAlign: 'middle' }}
              >
                {b.BrandName}
              </Link>
            ) : (
              // 有子層 → 只能展開收合
              <span
                onClick={() => toggleNode(b.BrandID)}
                className="menu-link py-2 flex-grow-1"
                style={{ cursor: 'pointer', verticalAlign: 'middle' }}
              >
                {b.BrandName}
              </span>
            )}

            {/* 右側：展開箭頭 */}
            {children.length > 0 && (
              <span
                onClick={() => toggleNode(b.BrandID)}
                style={{ cursor: 'pointer', fontSize: 16, userSelect: 'none' }}
              >
                {open ? <ChevronDown /> : <ChevronRight />}
              </span>
            )}
          </div>

          {/* 子層 */}
          {children.length > 0 && open && (
            <ul className="sub-menu__list list-unstyled ps-3">
              {renderBrand(children)}
            </ul>
          )}
        </li>
      )
    })
  }

  const renderCustom = (items = []) => {
    if (headerStyle?.CustomMenuStyle === 'picture') {
      return (
        <>
          {items.map((menu) => {
            const hasChildren =
              Array.isArray(menu.Children) && menu.Children.length > 0
            const href = menu.LinkURL || '#' // 若有自訂連結就導向

            return (
              <div key={menu.MenuID}>
                <div
                  className="d-flex align-items-center justify-content-between pt-2"
                  style={{ cursor: hasChildren ? 'pointer' : 'default' }}
                  onClick={() => {
                    // 只有有子層的時候才開關
                    if (hasChildren) {
                      setActiveMenu(
                        activeMenu?.MenuID === menu.MenuID ? null : menu
                      )
                    }
                  }}
                >
                  {/* 如果沒有 Children → 直接用 Link */}
                  {hasChildren ? (
                    <span className="menu-link fw-semibold flex-grow-1">
                      {menu.MenuName}
                    </span>
                  ) : (
                    <Link
                      href={href}
                      className="menu-link fw-semibold flex-grow-1 text-dark"
                      style={{ textDecoration: 'none' }}
                      onClick={() =>
                        document.body.classList.remove('mobile-menu-opened')
                      }
                    >
                      {menu.MenuName}
                    </Link>
                  )}

                  {/* 只有有 Children 才顯示箭頭 */}
                  {hasChildren && (
                    <span style={{ fontSize: 16 }}>
                      {activeMenu?.MenuID === menu.MenuID ? (
                        <ChevronDown />
                      ) : (
                        <ChevronRight />
                      )}
                    </span>
                  )}
                </div>

                {/* 有子層而且被展開時顯示圖片版面 */}
                {hasChildren && activeMenu?.MenuID === menu.MenuID && (
                  <MobileCustomPictureNav
                    activeMenu={menu}
                    selectors={selectors}
                  />
                )}
              </div>
            )
          })}
        </>
      )
    }

    return items.map((b) => {
      const children = hasChildren(b) ? b.Children : []
      const open = isExpanded(b.MenuID)
      const isLeaf = children.length === 0 // 沒有子層才可點
      const itemHref = resolveHref(b) // 判別 href 路徑

      return (
        <li key={`custom-${b.MenuID}`} className="navigation__item">
          <div className="d-flex align-items-center justify-content-between pt-2">
            {/* 左側：分類連結或展開 */}
            {isLeaf ? (
              // 沒子層 → 可以點擊導向
              <Link
                href={itemHref}
                className="menu-link py-2 flex-grow-1"
                onClick={() =>
                  document.body.classList.remove(
                    selectors.mobileMenuActiveClass
                  )
                }
              >
                {b.MenuName}
              </Link>
            ) : (
              // 有子層 → 只能展開收合
              <span
                onClick={() => toggleNode(b.MenuID)}
                className="menu-link py-2 flex-grow-1"
                style={{
                  cursor: 'pointer',
                }}
              >
                {b.MenuName}
              </span>
            )}

            {/* 右側：展開箭頭 */}
            {children.length > 0 && (
              <span
                onClick={() => toggleNode(b.MenuID)}
                style={{ cursor: 'pointer', fontSize: 16, userSelect: 'none' }}
              >
                {open ? <ChevronDown /> : <ChevronRight />}
              </span>
            )}
          </div>

          {/* 子層 */}
          {children.length > 0 && (
            <div
              className={`${styles.collapseWrapper} ${open ? styles.open : ''}`}
            >
              <ul className="sub-menu__list list-unstyled ps-3">
                {renderCustom(children)}
              </ul>
            </div>
          )}
        </li>
      )
    })
  }

  useEffect(() => {
    const mobileDropdown = document.querySelector(selectors.mobileMenu)

    const removeMenu = (event) => {
      if (event) {
        event.preventDefault()
      }

      if (document.body.classList.contains(selectors.mobileMenuActiveClass)) {
        document.body.classList.remove(selectors.mobileMenuActiveClass)
        document.body.style.paddingRight = ''
        mobileDropdown.style.paddingRight = ''
      }
    }
    removeMenu()
  }, [pathname])

  // if (isStoreItem) {
  //   return (
  //     <ul
  //       className={`navigation__list list-unstyled px-2`}
  //       style={{
  //         background: 'transparent',
  //         fontSize: '0.95rem',
  //         lineHeight: '1.8',
  //       }}
  //     >
  //       {storeInfoMenuItems.map((item, idx) => (
  //         <li
  //           key={idx}
  //           className="navigation__item"
  //           style={{ padding: '2px 0' }}
  //         >
  //           <Link
  //             href={item.href}
  //             className="menu-link d-block text-dark"
  //             onClick={() =>
  //               document.body.classList.remove('mobile-menu-opened')
  //             }
  //             style={{ textDecoration: 'none' }}
  //           >
  //             {item.title}
  //           </Link>
  //         </li>
  //       ))}
  //     </ul>
  //   )
  // }

  // if (isMemberItem) {
  //   return (
  //     <ul
  //       className={`navigation__list list-unstyled px-2`}
  //       style={{
  //         background: 'transparent',
  //         fontSize: '0.95rem',
  //         lineHeight: '1.8',
  //       }}
  //     >
  //       {dashboardMenuItems.map((item, idx) => (
  //         <li
  //           key={idx}
  //           className="navigation__item"
  //           style={{ padding: '2px 0' }}
  //         >
  //           <Link
  //             href={item.href}
  //             className="menu-link d-block text-dark"
  //             onClick={() =>
  //               document.body.classList.remove('mobile-menu-opened')
  //             }
  //             style={{ textDecoration: 'none' }}
  //           >
  //             {item.title}
  //           </Link>
  //         </li>
  //       ))}
  //     </ul>
  //   )
  // }

  return (
    <ul className="navigation__list list-unstyled">
      {/* 固定的父層：商品 */}
      {headerStyle?.GoodsCategoryEnable && (
        <li className="navigation__item">
          <div
            className="d-flex align-items-center justify-content-between pt-2"
            onClick={() => toggleNode('goods')}
          >
            <span className="menu-link fw-semibold flex-grow-1">商品</span>
            <span
              style={{ cursor: 'pointer', fontSize: 16, userSelect: 'none' }}
            >
              {isExpanded('goods') ? <ChevronDown /> : <ChevronRight />}
            </span>
          </div>

          {/* 子層分類（用 categoryItems 產生） */}
          <div
            className={`${styles.collapseWrapper} ${
              isExpanded('goods') ? styles.open : ''
            }`}
          >
            <ul className="sub-menu__list list-unstyled ps-3">
              {renderCategories(categoryItems)}
            </ul>
          </div>
        </li>
      )}
      {headerStyle?.BrandEnable && (
        <li className="navigation__item">
          <div
            className="d-flex align-items-center justify-content-between pt-2"
            onClick={() => toggleNode('brand')}
          >
            <span className="menu-link fw-semibold flex-grow-1">品牌</span>
            <span
              style={{ cursor: 'pointer', fontSize: 16, userSelect: 'none' }}
            >
              {isExpanded('brand') ? <ChevronDown /> : <ChevronRight />}
            </span>
          </div>

          {/* 子層分類（用 brand 產生） */}
          <div
            className={`${styles.collapseWrapper} ${
              isExpanded('brand') ? styles.open : ''
            }`}
          >
            <ul className="sub-menu__list list-unstyled ps-3">
              {renderBrand(brand)}
            </ul>
          </div>
        </li>
      )}
      {cusomNav && (
        <React.Fragment key="custom-nav">
          {renderCustom(cusomNav)}
        </React.Fragment>
      )}
    </ul>
  )
}
